// removed by extract-text-webpack-plugin
module.exports = {"labelTypography":"_14HwI","smallLinkTypography":"nHoN3","titleTypography":"_34ZVA","cardTitleTypography":"_39Dsy","truncate":"CdxGC","base":"_28-Sg","noBeneficiary":"M_-iZ","sectionTopHeader":"_3D28T","section":"VMTV8","sectionTitle":"_1qAqw","sectionContent":"_1QmFf","sectionLoading":"_2H5bD","sectionFooter":"_4mI55","linkButton":"_21M59","button":"_1yfsT","tip":"JH0Er","panel":"_3nccA","line":"_2aQvO","stepStatus":"_3WQmc","stepStatus2":"_2ZS-t","stepSymbol":"_2136J","stepDetails":"_3O8my","stepDetailsGreen":"_2CDqL","actions":"_1BBhY","greenAvatar":"_1FsUy","greyAvatar":"_1yj4q"};


//////////////////
// WEBPACK FOOTER
// ./src/views/FeatureToggle/FeatureToggle.scss
// module id = 2694
// module chunks = 0